/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../wire/ApiCaller";
import type { CamelToSnake } from "../wire/transform";
import type {
  CreateDependenciesRequest,
  CreateDependenciesResponse,
  CreateLinkTypeRequest,
  CreateLinkTypeResponse,
  CreateLinksRequest,
  CreateLinksResponse,
  CreateObjectiveLinkRequest,
  CreateObjectiveObjectiveLinkRequest,
  CreateTimerEventRequest,
  CreateTimerEventResponse,
  DeleteLinkRequest,
  DeleteLinksRequest,
  DeleteObjectiveLinkRequest,
  DeleteObjectiveObjectiveLinkRequest,
  GetAlmStickiesAcrossSessionsRequest,
  GetAlmStickiesAcrossSessionsResponse,
  GetAlmStickiesRequest,
  GetAlmStickiesResponse,
  GetArtsResponse,
  GetBoardIterationsRequest,
  GetBoardIterationsResponse,
  GetBoardResponse,
  GetBoardsResponse,
  GetBurndownChartDataRequest,
  GetBurndownChartDataResponse,
  GetCapacityAllocationRequest,
  GetCapacityAllocationResponse,
  GetCfdChartDataRequest,
  GetCfdChartDataResponse,
  GetDependenciesResponse,
  GetDependencyFlowRequest,
  GetDependencyFlowResponse,
  GetGroupBoardIdsResponse,
  GetIterationsResponse,
  GetLinkTypeResponse,
  GetLinkTypesResponse,
  GetLinksRequest,
  GetLinksResponse,
  GetParticipatingUsersResponse,
  GetPredictabilityRequest,
  GetPredictabilityResponse,
  GetSessionNameResponse,
  GetSessionResponse,
  GetSessionTeamIdsMappingRequest,
  GetSessionTeamIdsMappingResponse,
  GetSessionsResponse,
  GetSettingsResponse,
  GetStatusDistributionRequest,
  GetStatusDistributionResponse,
  GetStickerTypesResponse,
  GetStickiesByBoardIdsRequest,
  GetStickiesByBoardIdsResponse,
  GetStickiesRequest,
  GetStickiesResponse,
  GetStickyChangesResponse,
  GetStickyResponse,
  GetTeamsResponse,
  GetTimerEventsResponse,
  HasStickiesOfTypeOnBoardsRequest,
  HasStickiesOfTypeOnBoardsResponse,
  HasStickiesOfTypeRequest,
  HasStickiesOfTypeResponse,
  ImportCsvRequest,
  ImportResultResponse,
  NoData,
  SearchStickiesRequest,
  SearchStickiesResponse,
  SessionPlanningDates,
  SetIterationsRequest,
  SetParticipatingUsersRequest,
  SetSessionNameRequest,
  SetSettingsRequest,
  SetStickerTypesRequest,
  SetStickerTypesResponse,
  UpdateLinkTypeRequest,
  UpdateSwimlanesRequest,
  UpdateTimerEventRequest,
} from "./models";
import {
  createDependenciesResponseSchema,
  createLinkTypeResponseSchema,
  createLinksResponseSchema,
  createTimerEventResponseSchema,
  getAlmStickiesAcrossSessionsResponseSchema,
  getAlmStickiesResponseSchema,
  getArtsResponseSchema,
  getBoardIterationsResponseSchema,
  getBoardResponseSchema,
  getBoardsResponseSchema,
  getBurndownChartDataResponseSchema,
  getCapacityAllocationResponseSchema,
  getCfdChartDataResponseSchema,
  getDependenciesResponseSchema,
  getDependencyFlowResponseSchema,
  getGroupBoardIdsResponseSchema,
  getIterationsResponseSchema,
  getLinkTypeResponseSchema,
  getLinkTypesResponseSchema,
  getLinksResponseSchema,
  getParticipatingUsersResponseSchema,
  getPredictabilityResponseSchema,
  getSessionNameResponseSchema,
  getSessionResponseSchema,
  getSessionTeamIdsMappingResponseSchema,
  getSessionsResponseSchema,
  getStatusDistributionResponseSchema,
  getStickerTypesResponseSchema,
  getStickiesByBoardIdsResponseSchema,
  getStickiesResponseSchema,
  getStickyChangesResponseSchema,
  getStickyResponseSchema,
  getTeamsResponseSchema,
  getTimerEventsResponseSchema,
  hasStickiesOfTypeOnBoardsResponseSchema,
  hasStickiesOfTypeResponseSchema,
  importResultResponseSchema,
  noDataSchema,
  searchStickiesResponseSchema,
  sessionPlanningDatesSchema,
  setStickerTypesResponseSchema,
} from "./schemas";

export class SessionApiClient {
  constructor(private caller: ApiCaller) {}

  async getSessions(timeout?: number): Promise<GetSessionsResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.get",
        variables: {},
      },
      "getSessions",
      {},
      { schema: getSessionsResponseSchema, timeout },
    );
  }

  async getBoards(sessionId: string, timeout?: number): Promise<GetBoardsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.boards.get",
        variables: { sessionId: String(sessionId) },
      },
      "getBoards",
      {},
      { schema: getBoardsResponseSchema, timeout },
    );
  }

  async getAlmStickies(
    payload: GetAlmStickiesRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<GetAlmStickiesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.alm_stickies.get",
        variables: { sessionId: String(sessionId) },
      },
      "getAlmStickies",
      payload,
      { schema: getAlmStickiesResponseSchema, timeout },
    );
  }

  async getAlmStickiesAcrossSessions(
    payload: GetAlmStickiesAcrossSessionsRequest,
    timeout?: number,
  ): Promise<GetAlmStickiesAcrossSessionsResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.session.v1.alm_stickies.get",
        variables: {},
      },
      "getAlmStickiesAcrossSessions",
      payload,
      { schema: getAlmStickiesAcrossSessionsResponseSchema, timeout },
    );
  }

  async getIterations(sessionId: string, timeout?: number): Promise<GetIterationsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.iterations.get",
        variables: { sessionId: String(sessionId) },
      },
      "getIterations",
      {},
      { schema: getIterationsResponseSchema, timeout },
    );
  }

  async getBoardIterations(
    payload: GetBoardIterationsRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<GetBoardIterationsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.board_iterations.get",
        variables: { sessionId: String(sessionId) },
      },
      "getBoardIterations",
      payload,
      { schema: getBoardIterationsResponseSchema, timeout },
    );
  }

  async getTeams(sessionId: string, timeout?: number): Promise<GetTeamsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.teams.get",
        variables: { sessionId: String(sessionId) },
      },
      "getTeams",
      {},
      { schema: getTeamsResponseSchema, timeout },
    );
  }

  async getSessionTeamIdsMappings(
    payload: GetSessionTeamIdsMappingRequest,
    timeout?: number,
  ): Promise<GetSessionTeamIdsMappingResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.session.v1.session_team_ids_mappings.get",
        variables: {},
      },
      "getSessionTeamIdsMappings",
      payload,
      { schema: getSessionTeamIdsMappingResponseSchema, timeout },
    );
  }

  async getArts(sessionId: string, timeout?: number): Promise<GetArtsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.arts.get",
        variables: { sessionId: String(sessionId) },
      },
      "getArts",
      {},
      { schema: getArtsResponseSchema, timeout },
    );
  }

  async getSession(sessionId: string, timeout?: number): Promise<GetSessionResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.get",
        variables: { sessionId: String(sessionId) },
      },
      "getSession",
      {},
      { schema: getSessionResponseSchema, timeout },
    );
  }

  async archiveSession(sessionId: string, timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.archive",
        variables: { sessionId: String(sessionId) },
      },
      "archiveSession",
      {},
      { schema: noDataSchema, timeout },
    );
  }

  async deleteSession(sessionId: string, timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.delete",
        variables: { sessionId: String(sessionId) },
      },
      "deleteSession",
      {},
      { schema: noDataSchema, timeout },
    );
  }

  async getDependencies(sessionId: string, timeout?: number): Promise<GetDependenciesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.dependencies.get",
        variables: { sessionId: String(sessionId) },
      },
      "getDependencies",
      {},
      { schema: getDependenciesResponseSchema, timeout },
    );
  }

  async createDependency(
    payload: CreateDependenciesRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<CreateDependenciesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.dependencies.create",
        variables: { sessionId: String(sessionId) },
      },
      "createDependency",
      payload,
      { schema: createDependenciesResponseSchema, timeout },
    );
  }

  async getSettings(
    sessionId: string,
    timeout?: number,
  ): Promise<CamelToSnake<GetSettingsResponse>> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.settings.get",
        variables: { sessionId: String(sessionId) },
      },
      "getSettings",
      {},
      { timeout },
    );
  }

  async setSettings(
    payload: SetSettingsRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.settings.set",
        variables: { sessionId: String(sessionId) },
      },
      "setSettings",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getLinkTypes(sessionId: string, timeout?: number): Promise<GetLinkTypesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.link_types.get",
        variables: { sessionId: String(sessionId) },
      },
      "getLinkTypes",
      {},
      { schema: getLinkTypesResponseSchema, timeout },
    );
  }

  async createLinkType(
    payload: CreateLinkTypeRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<CreateLinkTypeResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.link_types.create",
        variables: { sessionId: String(sessionId) },
      },
      "createLinkType",
      payload,
      { schema: createLinkTypeResponseSchema, timeout },
    );
  }

  async getLinkType(
    sessionId: string,
    linkTypeId: string,
    timeout?: number,
  ): Promise<GetLinkTypeResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.link_types.${linkTypeId}.get",
        variables: { sessionId: String(sessionId), linkTypeId: String(linkTypeId) },
      },
      "getLinkType",
      {},
      { schema: getLinkTypeResponseSchema, timeout },
    );
  }

  async updateLinkType(
    payload: UpdateLinkTypeRequest,
    sessionId: string,
    linkTypeId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.link_types.${linkTypeId}.update",
        variables: { sessionId: String(sessionId), linkTypeId: String(linkTypeId) },
      },
      "updateLinkType",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async deleteLinkType(sessionId: string, linkTypeId: string, timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.link_types.${linkTypeId}.delete",
        variables: { sessionId: String(sessionId), linkTypeId: String(linkTypeId) },
      },
      "deleteLinkType",
      {},
      { schema: noDataSchema, timeout },
    );
  }

  async getLinksInSession(sessionId: string, timeout?: number): Promise<GetLinksResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.links.get",
        variables: { sessionId: String(sessionId) },
      },
      "getLinksInSession",
      {},
      { schema: getLinksResponseSchema, timeout },
    );
  }

  async createLink(
    payload: CreateLinksRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<CreateLinksResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.links.create",
        variables: { sessionId: String(sessionId) },
      },
      "createLink",
      payload,
      { schema: createLinksResponseSchema, timeout },
    );
  }

  async deleteLinks(
    payload: DeleteLinksRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.links.delete",
        variables: { sessionId: String(sessionId) },
      },
      "deleteLinks",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async loadBacklogCsv(
    payload: ImportCsvRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<ImportResultResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.backlog_csv.load",
        variables: { sessionId: String(sessionId) },
      },
      "loadBacklogCsv",
      payload,
      { schema: importResultResponseSchema, timeout },
    );
  }

  async loadTeamCsv(
    payload: ImportCsvRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<ImportResultResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.team_csv.load",
        variables: { sessionId: String(sessionId) },
      },
      "loadTeamCsv",
      payload,
      { schema: importResultResponseSchema, timeout },
    );
  }

  async loadJalignXlsx(
    payload: ImportCsvRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<ImportResultResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.jalign_xlsx.load",
        variables: { sessionId: String(sessionId) },
      },
      "loadJalignXlsx",
      payload,
      { schema: importResultResponseSchema, timeout },
    );
  }

  async getSticky(stickyId: string, timeout?: number): Promise<GetStickyResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.session.v1.stickies.${stickyId}.get",
        variables: { stickyId: String(stickyId) },
      },
      "getSticky",
      {},
      { schema: getStickyResponseSchema, timeout },
    );
  }

  async getBoardIdsOfGroupedStickies(
    stickyId: string,
    timeout?: number,
  ): Promise<GetGroupBoardIdsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.stickies.${stickyId}.group_boards.get",
        variables: { stickyId: String(stickyId) },
      },
      "getBoardIdsOfGroupedStickies",
      {},
      { schema: getGroupBoardIdsResponseSchema, timeout },
    );
  }

  async getStickyChanges(stickyId: string, timeout?: number): Promise<GetStickyChangesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.stickies.${stickyId}.changes.get",
        variables: { stickyId: String(stickyId) },
      },
      "getStickyChanges",
      {},
      { schema: getStickyChangesResponseSchema, timeout },
    );
  }

  async getBoard(boardId: string, timeout?: number): Promise<GetBoardResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.session.v1.boards.${boardId}.get",
        variables: { boardId: String(boardId) },
      },
      "getBoard",
      {},
      { schema: getBoardResponseSchema, timeout },
    );
  }

  async getLinksByStickyIds(payload: GetLinksRequest, timeout?: number): Promise<GetLinksResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.session.v1.links.get",
        variables: {},
      },
      "getLinksByStickyIds",
      payload,
      { schema: getLinksResponseSchema, timeout },
    );
  }

  async deleteLink(payload: DeleteLinkRequest, linkId: string, timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.session.v1.links.${linkId}.delete",
        variables: { linkId: String(linkId) },
      },
      "deleteLink",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getName(sessionId: string, timeout?: number): Promise<GetSessionNameResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.name.get",
        variables: { sessionId: String(sessionId) },
      },
      "getName",
      {},
      { schema: getSessionNameResponseSchema, timeout },
    );
  }

  async setName(
    payload: SetSessionNameRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.name.set",
        variables: { sessionId: String(sessionId) },
      },
      "setName",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getPlanningDates(sessionId: string, timeout?: number): Promise<SessionPlanningDates> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.planning_dates.get",
        variables: { sessionId: String(sessionId) },
      },
      "getPlanningDates",
      {},
      { schema: sessionPlanningDatesSchema, timeout },
    );
  }

  async setPlanningDates(
    payload: SessionPlanningDates,
    sessionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.planning_dates.set",
        variables: { sessionId: String(sessionId) },
      },
      "setPlanningDates",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getParticipatingUsers(
    sessionId: string,
    timeout?: number,
  ): Promise<GetParticipatingUsersResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.participating_users.get",
        variables: { sessionId: String(sessionId) },
      },
      "getParticipatingUsers",
      {},
      { schema: getParticipatingUsersResponseSchema, timeout },
    );
  }

  async setParticipatingUsers(
    payload: SetParticipatingUsersRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.participating_users.set",
        variables: { sessionId: String(sessionId) },
      },
      "setParticipatingUsers",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async setIterations(
    payload: SetIterationsRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.iterations.set",
        variables: { sessionId: String(sessionId) },
      },
      "setIterations",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async updateSwimlanes(
    payload: UpdateSwimlanesRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.swimlanes.update",
        variables: { sessionId: String(sessionId) },
      },
      "updateSwimlanes",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getStickerTypes(sessionId: string, timeout?: number): Promise<GetStickerTypesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.sticker_types.get",
        variables: { sessionId: String(sessionId) },
      },
      "getStickerTypes",
      {},
      { schema: getStickerTypesResponseSchema, timeout },
    );
  }

  async setStickerTypes(
    payload: SetStickerTypesRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<SetStickerTypesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.sticker_types.set",
        variables: { sessionId: String(sessionId) },
      },
      "setStickerTypes",
      payload,
      { schema: setStickerTypesResponseSchema, timeout },
    );
  }

  async unarchiveSession(sessionId: string, timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.unarchive",
        variables: { sessionId: String(sessionId) },
      },
      "unarchiveSession",
      {},
      { schema: noDataSchema, timeout },
    );
  }

  async getStickies(
    payload: GetStickiesRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<GetStickiesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.stickies.get",
        variables: { sessionId: String(sessionId) },
      },
      "getStickies",
      payload,
      { schema: getStickiesResponseSchema, timeout },
    );
  }

  async searchStickies(
    payload: SearchStickiesRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<SearchStickiesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.stickies.search",
        variables: { sessionId: String(sessionId) },
      },
      "searchStickies",
      payload,
      { schema: searchStickiesResponseSchema, timeout },
    );
  }

  async hasStickiesOfType(
    payload: HasStickiesOfTypeRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<HasStickiesOfTypeResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.stickies.has_of_type.get",
        variables: { sessionId: String(sessionId) },
      },
      "hasStickiesOfType",
      payload,
      { schema: hasStickiesOfTypeResponseSchema, timeout },
    );
  }

  async getStickiesByBoardIds(
    payload: GetStickiesByBoardIdsRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<GetStickiesByBoardIdsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.stickies.by_board_ids.get",
        variables: { sessionId: String(sessionId) },
      },
      "getStickiesByBoardIds",
      payload,
      { schema: getStickiesByBoardIdsResponseSchema, timeout },
    );
  }

  async hasStickiesOfTypeOnBoards(
    payload: HasStickiesOfTypeOnBoardsRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<HasStickiesOfTypeOnBoardsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.stickies.has_of_type_on_boards.get",
        variables: { sessionId: String(sessionId) },
      },
      "hasStickiesOfTypeOnBoards",
      payload,
      { schema: hasStickiesOfTypeOnBoardsResponseSchema, timeout },
    );
  }

  async deleteUnusedStickyType(
    sessionId: string,
    stickyTypeId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.sticky_types.${stickyTypeId}.unused.delete",
        variables: { sessionId: String(sessionId), stickyTypeId: String(stickyTypeId) },
      },
      "deleteUnusedStickyType",
      {},
      { schema: noDataSchema, timeout },
    );
  }

  async createObjectiveLink(
    payload: CreateObjectiveLinkRequest,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.session.v1.objective_links.create",
        variables: {},
      },
      "createObjectiveLink",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async deleteObjectiveLink(
    payload: DeleteObjectiveLinkRequest,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.session.v1.objective_links.delete",
        variables: {},
      },
      "deleteObjectiveLink",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async createObjectiveObjectiveLink(
    payload: CreateObjectiveObjectiveLinkRequest,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.objective_objective_links.create",
        variables: {},
      },
      "createObjectiveObjectiveLink",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async deleteObjectiveObjectiveLinks(
    payload: DeleteObjectiveObjectiveLinkRequest,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.objective_objective_links.delete",
        variables: {},
      },
      "deleteObjectiveObjectiveLinks",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async createTimer(
    payload: CreateTimerEventRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<CreateTimerEventResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.timers.create",
        variables: { sessionId: String(sessionId) },
      },
      "createTimer",
      payload,
      { schema: createTimerEventResponseSchema, timeout },
    );
  }

  async deleteTimer(sessionId: string, timerId: string, timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.timers.${timerId}.delete",
        variables: { sessionId: String(sessionId), timerId: String(timerId) },
      },
      "deleteTimer",
      {},
      { schema: noDataSchema, timeout },
    );
  }

  async getTimers(sessionId: string, timeout?: number): Promise<GetTimerEventsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.timers.get",
        variables: { sessionId: String(sessionId) },
      },
      "getTimers",
      {},
      { schema: getTimerEventsResponseSchema, timeout },
    );
  }

  async updateTimer(
    payload: UpdateTimerEventRequest,
    sessionId: string,
    timerId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.timers.${timerId}.update",
        variables: { sessionId: String(sessionId), timerId: String(timerId) },
      },
      "updateTimer",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getStatusDistribution(
    payload: GetStatusDistributionRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<GetStatusDistributionResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.status_distribution.get",
        variables: { sessionId: String(sessionId) },
      },
      "getStatusDistribution",
      payload,
      { schema: getStatusDistributionResponseSchema, timeout },
    );
  }

  async getCapacityAllocation(
    payload: GetCapacityAllocationRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<GetCapacityAllocationResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.analytics.capacity_allocation.get",
        variables: { sessionId: String(sessionId) },
      },
      "getCapacityAllocation",
      payload,
      { schema: getCapacityAllocationResponseSchema, timeout },
    );
  }

  async getDependencyFlow(
    payload: GetDependencyFlowRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<GetDependencyFlowResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.analytics.dependency_flow.get",
        variables: { sessionId: String(sessionId) },
      },
      "getDependencyFlow",
      payload,
      { schema: getDependencyFlowResponseSchema, timeout },
    );
  }

  async getBurndown(
    payload: GetBurndownChartDataRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<GetBurndownChartDataResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.analytics.burndown.get",
        variables: { sessionId: String(sessionId) },
      },
      "getBurndown",
      payload,
      { schema: getBurndownChartDataResponseSchema, timeout },
    );
  }

  async getCfd(
    payload: GetCfdChartDataRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<GetCfdChartDataResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.analytics.cfd.get",
        variables: { sessionId: String(sessionId) },
      },
      "getCfd",
      payload,
      { schema: getCfdChartDataResponseSchema, timeout },
    );
  }

  async getPredictability(
    payload: GetPredictabilityRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<GetPredictabilityResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.session.v1.sessions.${sessionId}.analytics.predictability.get",
        variables: { sessionId: String(sessionId) },
      },
      "getPredictability",
      payload,
      { schema: getPredictabilityResponseSchema, timeout },
    );
  }
}
